import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { DtAddressService } from '../../../service/dt-address/dt-address.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { DeliRouteService } from '../../../service/deli-route/deli-route.service';
import { CarrierService } from '../../../service/carrier/carrier.service';
import { PrefService } from '../../../service/pref/pref.service';
import { TypeShipInvoiceService } from '../../../service/type-shipinvoice/type-shipinvoice.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { validation } from '../../../util/validation';
import { isSingleOwner } from 'app/menu/header/header.component';

@Component({
  selector: 'wa9142',
  templateUrl: './wa9142.component.html',
  styleUrls: ['./wa9142.component.scss']
})
export class Wa9142Component implements OnInit {
  public componentTitle = 'WA9142:届先マスタ登録';

  // public ownerId: FormControl;
  public dtaddressCd: FormControl;
  public dtnameTx: FormControl;
  public dtpostalCd: FormControl;
  public dtaddress1Tx: FormControl;
  public dtaddress2Tx: FormControl;
  public dtaddress3Tx: FormControl;
  // public dtdepartmentTx: FormControl;
  public dttelTx: FormControl;
  public validation = validation;

  public owners: any;
  public carriers: any;
  public prefs: any;
  public deliroutes: any;
  public typeshipinvoices: any;
  public ownerResult: any;
  // public selectedOwnerId:number;

  public ownerId: number;
  public prefTx: string;
  public carrierCd: FormControl;
  public delirouteId: FormControl;
  public delirouteCd: string;
  public typeshipinvoiceCd: string;
  public freeItem1Tx: FormControl;
  public freeItem2Tx: FormControl;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  public rootFormGroup: FormGroup;
  public dump = '';
  private errorInfo = '';

  private ownerIdCls = '';
  private dtaddressCdCls = '';
  private dtnameTxCls = '';
  private dtpostalCdCls = '';
  private dtaddress1TxCls = '';
  private dtaddress2TxCls = '';
  private dtaddress3TxCls = '';
  private dttelTxCls = '';
  private carrierCdCls = '';
  private delirouteIdCls = '';
  private typeshipinvoiceCdCls = '';
  private freeItem1TxCls = '';
  private freeItem2TxCls = '';

  @Input() isShow = false;
  @Input() selectedOwnerId;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;
  private isOwnerFixed = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  @ViewChild('scrollContent')
  scrollContent: ElementRef

  constructor(
    private router: Router,
    private ownerService: OwnerService,
    private carrierService: CarrierService,
    private prefService: PrefService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private formbuilder: FormBuilder,
    private dtAddressService: DtAddressService,
    private deliRouteService: DeliRouteService,
    private typeShipInvoiceService: TypeShipInvoiceService
  ) {
    this.dtaddressCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.maxLength(validation.dtaddressCd.maxLength)
    ]);
    this.dtnameTx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.dtnameTx.maxLength)
    ]);
    this.dtpostalCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.pattern(validation.dtpostalCd.postcode),
      Validators.maxLength(validation.dtpostalCd.maxLength)
    ]);
    this.dtaddress1Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.dtaddress1Tx.maxLength)
    ]);
    this.dtaddress2Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.dtaddress2Tx.maxLength)
    ]);
    this.dtaddress3Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.dtaddress3Tx.maxLength)
    ]);
    // this.dtdepartmentTx = new FormControl('', [
    //   Validators.pattern(validation.emBlankOnly),
    //   Validators.pattern(validation.halfBlankOnly),
    //   Validators.maxLength(validation.dtdepartmentTx.maxLength),
    // ]);
    this.dttelTx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.dttelTx.tel),
      Validators.maxLength(validation.dttelTx.maxLength)
    ]);

    this.carrierCd = new FormControl('', [
      Validators.required
    ]);
    this.delirouteId = new FormControl('', [
      Validators.required
    ]);
    this.freeItem1Tx = new FormControl('', [
      Validators.maxLength(validation.freeItem1Tx.maxLength)
    ]);
    this.freeItem2Tx = new FormControl('', [
      Validators.maxLength(validation.freeItem2Tx.maxLength)
    ]);

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.working = true;
    
    this.carrierService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        this.carriers = __outputJson.carriers;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.prefService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        this.prefs = __outputJson.prefs;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.deliRouteService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.deliroutes.push({ delirouteId: 0, delirouteTx: '選択しない' });
        this.deliroutes = __outputJson.deliroutes;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.typeShipInvoiceService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.typeshipinvoices.push({ typeshipinvoiceCd: '', typeshipinvoiceTx: '選択しない' });
        this.typeshipinvoices = __outputJson.typeshipinvoices;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    this.errorInfo = '';

    if (!this.isSubmitButtonEnabled)
      return;

    let errors = false;
    var dtaddressCd = this.dtaddressCd.value.trim();
    var dtnameTx = this.dtnameTx.value.trim();
    var dtpostalCd = this.dtpostalCd.value.trim();
    var dtaddress2Tx = this.dtaddress2Tx.value.trim();
    var dtaddress1Tx = this.dtaddress1Tx.value.trim();
    var dtaddress3Tx = this.dtaddress3Tx.value.trim();
    // var dtdepartmentTx = this.dtdepartmentTx.value.trim();
    var dttelTx = this.dttelTx.value.trim();
    var freeItem1Tx = this.freeItem1Tx.value.trim();
    var freeItem2Tx = this.freeItem2Tx.value.trim();

    if (this.dtaddressCd.errors !== null) {
      this.dtaddressCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.dtnameTx.errors !== null) {
      this.dtnameTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.dtpostalCd.errors !== null) {
      this.dtpostalCd.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (this.dtaddress1Tx.errors !== null) {
      this.dtaddress1Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    // if (this.dtdepartmentTx.errors !== null) {
    //   this.dtdepartmentTx.markAsTouched({ onlySelf: true });
    //   errors = true;
    // }
    if (this.dttelTx.errors !== null) {
      this.dttelTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.freeItem1Tx.errors !== null) {
      this.freeItem1Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.freeItem2Tx.errors !== null) {
      this.freeItem2Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (errors) {
      return;
    }

    if (this.ownerId === undefined) {
      this.errorInfo = '荷主を選択してください';
      return;
    }
    if (this.carrierCd.value === undefined) {
      this.errorInfo = '配送方法を選択してください';
      return;
    }
    /*
    if (this.delirouteId.value === undefined) {
      this.errorInfo = '配送ルート名を選択してください';
      return;
    } else {
      if (this.delirouteId.value == '0') {
        this.delirouteCd = '';
      } else {
        for (let i = 0; i < this.deliroutes.length; i++) {
          if (this.deliroutes[i]['delirouteId'] == this.delirouteId) {
            this.delirouteCd = this.deliroutes[i]['delirouteCd'];
          }
        }
      }
    }
    */
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.dtAddressService
      .post(
        this.ownerId,
        dtaddressCd,
        dtnameTx,
        dtpostalCd,
        dtaddress1Tx,
        dtaddress2Tx,
        dtaddress3Tx,
        '',
        dttelTx,
        this.carrierCd.value,
        this.delirouteId.value,
        this.delirouteCd,
        this.typeshipinvoiceCd,
        freeItem1Tx,
        freeItem2Tx,
        'wa9142'
      )
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    this.ownerService
      .get()
      .then(outputJson => {
        console.log(outputJson);
        this.owners = outputJson.owners;
        this.selectedOwnerId = undefined;
        if (sessionStorage.getItem('ownerResult'))
          this.selectedOwnerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
        if (this.selectedOwnerId) {
          this.owners = outputJson.owners.filter((item, index) => {
            if (item.ownerId === this.selectedOwnerId) return true;
          });
          this.ownerId = this.selectedOwnerId;
        } else {
          this.owners = outputJson.owners;
          this.ownerId = null;
        }
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });

    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();

      setTimeout(() => {
        this.scrollContent.nativeElement.scrollTop = 0;
      }, 200);
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.errorInfo = '';
    this.dtaddressCd.setValue('');
    this.dtnameTx.setValue('');
    this.dtpostalCd.setValue('');
    this.dtaddress1Tx.setValue('');
    this.dtaddress2Tx.setValue('');
    this.dtaddress3Tx.setValue('');
    this.dttelTx.setValue('');

    this.ownerId = undefined;
    this.carrierCd.setValue('');
    this.delirouteId.setValue('0');
    this.delirouteCd = null;
    this.typeshipinvoiceCd = undefined;
    this.freeItem1Tx.setValue('');
    this.freeItem2Tx.setValue('');

    this.isSubmitButtonEnabled = false;
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    this.ownerIdCls = this.ownerId == null || this.ownerId === undefined || this.ownerId + '' === 'undefined' ? '' : (this.ownerId + '' === '' ? this.STRINGS_ERROR : this.STRINGS_ACTIVE);
    this.dtaddressCdCls = this.dtaddressCd.value === '' ? '' : (this.dtaddressCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dtnameTxCls = this.dtnameTx.value === '' ? '' : (this.dtnameTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dtpostalCdCls = this.dtpostalCd.value === '' ? '' : (this.dtpostalCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dtaddress1TxCls = this.dtaddress1Tx.value === '' ? '' : (this.dtaddress1Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dtaddress2TxCls = this.dtaddress2Tx.value === '' ? '' : (this.dtaddress2Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dtaddress3TxCls = this.dtaddress3Tx.value === '' ? '' : (this.dtaddress3Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dttelTxCls = this.dttelTx.value === '' ? '' : (this.dttelTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.carrierCdCls = this.carrierCd.value === '' ? '' : (this.carrierCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.delirouteIdCls = this.delirouteId.value + '' === '0' ? '' : (this.delirouteId.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.typeshipinvoiceCdCls = (this.typeshipinvoiceCd === undefined || this.typeshipinvoiceCd === 'undefined' || this.typeshipinvoiceCd + '' === '') ? '' : this.STRINGS_ACTIVE;
    this.freeItem1TxCls = this.freeItem1Tx.value === '' ? '' : (this.freeItem1Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.freeItem2TxCls = this.freeItem2Tx.value === '' ? '' : (this.freeItem2Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);

    this.checkSubmitButtonState();

    if (isSingleOwner) {
      this.isOwnerFixed = true;
    } else this.isOwnerFixed = false;
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled = this.ownerIdCls === this.STRINGS_ACTIVE &&
      this.dtaddressCdCls === this.STRINGS_ACTIVE &&
      this.dtnameTxCls === this.STRINGS_ACTIVE &&
      this.dtpostalCdCls === this.STRINGS_ACTIVE &&
      this.dtaddress1TxCls === this.STRINGS_ACTIVE &&
      this.dttelTxCls === this.STRINGS_ACTIVE &&
      this.carrierCdCls === this.STRINGS_ACTIVE;
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9142/wa9142.component.ts